module.exports = __webpack_public_path__ + "static/empyrean-75a01fb7f2fd21c99f2a5a2b6f946847.jpeg";